<template>
  <div class="layout">
    <Header />
    <div class="content">
      <!-- 侧边栏 -->
      <Sidebar></Sidebar>
      <div class="side-right">
        <!-- 顶部栏 -->
        <Navbar style="margin-bottom: 28px;"></Navbar>
        <div class="router-view">
          <transition name="el-zoom-in-top">
          <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
    <QuickEntry />
    <TipBar style="bottom: 80px;"/>
    <Footer :hide-connect="true" />
  </div>
</template>

<script>
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
export default {
  components: {
    Sidebar,
    Navbar
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.layout {
  min-height: 100vh;
  background: #f6f7fc;
  .content {
    display: flex;
    justify-content: space-between;
    width: 1320px;
    min-height: calc(100vh - 184px);
    margin: 40px auto;
    .side-right {
      display: flex;
      flex-direction: column;
      width: 1060px;
      .router-view {
        // flex: 1 1 0%;
        width: 1060px;
        // min-height: calc(100vh - 184px - 42px);
        background: #FFF;
      }
    }
  }
}
</style>
